<div class="pageheader">
  <div class="page-title">
    <h1>System Integrated FTP Provider</h1>
    <div class="btn-group">
      <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'System Integrated FTP Provider log'">
        <app-change-log-link-entity type="SystemIntegratedFtpProvider"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<div class="container container-fixed" [formGroup]="form">
  <div class="row" formGroupName="providerSettings">
    <div class="col-md-6">
      <div class="form-group">
        <div class="control">
          <label>Integrated FTP provider</label>
          <select class="form-control" formControlName="provider">
            <option [ngValue]="null">None</option>
            @for (item of integratedFtpProviders; track item) {
              <option [ngValue]="item.Id" [title]="item.Description">
                {{item.Name}}
              </option>
            }
          </select>
        </div>
      </div>
    </div>

    @if (fcProvider.value) {
      <div class="col-md-6">
        <div class="form-group">
          <div class="control">
            <label title="Name or IP address for the FTP server.">FTP host</label>
            <input class="form-control" formControlName="host" [readonly]="!editing" type="text" />
            <div [class.invisible]="!fcHost.invalid">
              <span class="error">This field is required</span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  @if (systemIntegratedFtpProviderDisplayGroups.length > 0) {
    <div class="row">
      <div class="col-md-12" style="margin-bottom: 3rem">
        <ep-datafield-group-container #dfgContainer [isAlwaysEditable]="false" [formValidationGroup]="form.get('config')" [showError]="true"
        [datafieldGroups]="systemIntegratedFtpProviderDisplayGroups" [numberOfColumns]="2"></ep-datafield-group-container>
      </div>
    </div>
  }
  <div class="row">
    <div class="col-md-12">
      @if (!editing) {
        <button class="btn btn-primary" (click)="edit()">Edit</button>
      }
      @if (editing) {
        <button class="btn btn-primary" (click)="save()" [disabled]="form.invalid">Save</button>
      }
      @if (editing) {
        <button class="btn btn-link" (click)="cancel()">Cancel</button>
      }
    </div>
  </div>
</div>
